import { useState, useEffect } from 'react'
import { getAllowedClinicsForManager } from 'src/supportPortal/services/rosterManagementService'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'

export function useAllowedClinics(isClinicRosterManager) {
  const [allowedClinicIds, setAllowedClinicIds] = useState([])
  const [allowedClinics, setAllowedClinics] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    async function fetchAllowedClinics() {
      if (!isClinicRosterManager) {
        // Admin has access to all clinics
        setAllowedClinicIds(null) // null means all clinics
        setAllowedClinics([])
        return
      }

      setLoading(true)
      try {
        const resp = await getAllowedClinicsForManager()
        if (resp.status === 200 && isCommonResponseSuccessfulV2(resp)) {
          const data = getDataMapFromCommonResponse(resp)
          const clinics = data.allowedClinics || []
          // Support both id and clinicBrandId fields (API returns clinicBrandId)
          const clinicIds = clinics.map((c) => c.clinicBrandId || c.id) || []
          setAllowedClinicIds(clinicIds)
          setAllowedClinics(clinics)
          // Note: targetSpecialitySlugs is available in each clinic object for future use
        }
      } catch (err) {
        console.error('Error fetching allowed clinics:', err)
      } finally {
        setLoading(false)
      }
    }

    fetchAllowedClinics()
  }, [isClinicRosterManager])

  return { allowedClinicIds, allowedClinics, loading }
}
